<template>
  <div  v-if="deviceID != ''" :style="{backgroundColor: bgColor}">
    <v-layout row style="margin-left:10px;">
      <v-flex xs6> 
        <dateRangePicker :dark="dark" @daterange="setDateRange" :auto="true" />
      </v-flex>
      <v-spacer />
      <v-flex xs4 justify-end>
        <v-slider 
          label="Gauge Size" 
          thumb-label 
          :max="200"
          :min="50"
          v-model="size"> 
        </v-slider>
      </v-flex>
      <v-spacer />
    </v-layout>
    <v-layout justify-center>
    <GaugeArray :size="size" :deviceID="deviceID" :dt.sync="dt"/>
    </v-layout>
    <v-layout row>
    <v-layout row style="margin-left: 20px;">

      &nbsp; Last Reading: {{dt}}

    </v-layout>
    <v-layout row justify-end style="margin-right: 20px;">
      Click on Chart Legend to Show/Hide Individual Graphs &nbsp;
    </v-layout>
  </v-layout >
  <v-layout justify-center>
    <GChart  v-if="chartData.length > 0 && !nodata && !loading" style="height: 100%;"
      :settings="({packages: ['corechart', 'controls']})"
      type="LineChart"
      :data = "chartData"
      :options = "chartOptions"
      :resizeDebounce="500"
      @ready="onChartReady"
    >
    </GChart>
    </v-layout>
    <div style="text-align: center; vertical-align: middle; line-height: 500px" v-if="nodata">
      No sensor readings found for that time period...
    </div>
    <div style="text-align: center; vertical-align: middle; line-height: 500px" v-if="loading">
      Loading...
    </div>
  </div>
</template>

<script type="text/babel">
  import { sync } from 'vuex-pathify'
  import { GChart } from 'vue-google-charts'
  import { debounce } from 'vue-debounce'
  import dateRangePicker from '@/../../coreui/library/DateRangePicker'
  import moment from 'moment'
  import axiosInstances from '@/../../coreui/server/axiosInstances'
  import querystring from 'querystring'
  import GaugeArray from './GaugeArray'
  import ui from '@/../../coreui/helpers/ui'


  export default {
    props: ['deviceID'],
    components: {
      GChart,
      dateRangePicker,
      GaugeArray
    },
    data () {
      const that = this
      return {
        nodata: true,
        loading: false,
        dt: null,
        size: 100,
        chart: null,
        series: {},
        columns: [],
        sensorData: [],
        chartData: [

        ],
        chartOptions: {
          displayAnnotations: true,
          explorer: {
            axis: 'horizontal',
            actions: ['dragToZoom', 'rightClickToReset'],
            keepInBounds: true,
            maxZoomIn: 100.0
          },
          aggregationTarget: 'category',
          chartArea: {left:"5%",top:"10%",right:"20%",bottom:"10%"},
          height: window.innerHeight - 250,
          width: window.innerWidth - 100,
          title: '',
          subtitle: 'Click on Legend to Hide Each Sensor',
          titleTextStyle: {
              color: 'blue',    
              fontSize: '24',
              bold: true,    // true or false
              italic: false   // true of false
          },
          curveType: 'function',
          selectionMode: 'single',
          tooltip: {trigger: 'selection'},
          aggregationTarget: 'none',
          legend: { position: 'right', alignment: 'start' },
          vAxis: {
            gridlines: {
              color: 'lightGray'
            },
          },
          hAxis: {
            format: 'M/d/yy,HH:mm',
            gridlines: {
              color: 'lightGray',
              count: 15
            },
          },
          series: this.series
        },
      }
    },
    computed: {
      dark: sync('misc/dark'),
      dictionary: sync('table/dictionary'),
      orgSensors: sync('table/orgSensors'),
      bgColor () {
        return  this.dark ? '#303030' : ui.theme(this.dark).backgroundcolor 
      }
    },
    watch: {
      
      dark: {
        immediate: true,
        handler( val, old) {         
          if (val) {
            this.chartOptions.backgroundColor = { fill: '#303030'}
            this.chartOptions.hAxis.textStyle = {color: '#FFFFFF'}
            this.chartOptions.vAxis.textStyle = {color: '#FFFFFF'}
            this.chartOptions.legend.textStyle = {color: '#FFFFFF'}
            this.chartOptions.titleTextStyle = {color: 'yellow', fontSize: 24}
          } else {
            this.chartOptions.backgroundColor= {fill : '#FAFAFA' }
            this.chartOptions.hAxis.textStyle = {color: '#020202'}
            this.chartOptions.vAxis.textStyle = {color: '#040404'}
            this.chartOptions.legend.textStyle = {color: '#060606'}
            this.chartOptions.titleTextStyle = {color: 'blue', fontSize: 24}
          }
        }
      },
      sensorData: {
        handler (val, old) {
          if (val == null || val.length == 0) {
            this.nodata = true
            return
          }
          this.nodata = false
          var that = this
          var keys = []
          var gauges = []
          that.chartData = []
          this.series= {}
          this.columns= []
          let firstRow = []
          var self = this
          firstRow = val[0] ? Object.keys(val[0]['data']) : []
          firstRow.unshift('ts')
          let j = 0
          var xx = firstRow.map((i) => {
            let h = this.getDictionaryItem(i)
            if (h == null) return i
            let u = h['unit'] != null && h['unit'] != ''  ? ' (' + h['unit'] + ')' : ''
            self.series[j] = {axis: h['label'] + u}
            self.columns.push(j++)
            return h['label'] + u
          })
          self.columns.push(j)
          that.chartData[0] = xx
          for (var i = 0; i < val.length; i++) {
            let row = []
            let item = val[i]
            row[0] = new Date(item['ts'])
            var d = item['data']
            for (j = 0; j < Object.keys(d).length; j++) {
              let x = parseFloat(d[Object.keys(d)[j]].toString())
              row[j+1] =  x == NaN ? 0.0 : x
            }
            that.chartData[i+1] = row
          }
        }
      }
    },
    methods: {
      async initLast200() {
        var deviceID = this.deviceID
        var code = null
        var last = 200
        let query = '/dt/v1/' + deviceID 
        let params = {}
        if (code) {
          params.return = 'ts'
          params.return = 'data.'+code
        }
        if (last) {
          params.last = last
        }
        if (Object.keys(query).length > 0) {
          query += '?' + querystring.stringify(params)
        }
        try {
            var table = await axiosInstances.apiServer.get(query)
            if (table == null || table.data == null || table.data.length == 0) {
              this.nodata = true
              return
            }
            var data = table.data.map(function(item) {
              if (code) {
                return {ts: item.ts, data: item.data[code]}
              } else {
                return {ts: item.ts, data: item.data}
              }
            })
        } catch (ex) {
          console.log(ex)
          commit('SET_ALERT', {
            show: true,
            msg: 'Can not fetch data for ' + deviceID,
            color: 'error'
          })
          return
        }
        this.sensorData = data
        this.nodata = false
      },
      setDateRange(val) {
        if (val == null) {
          this.initLast200()
          return
        }
        var start = moment(val.start).format("DD/MMM/yyyy:HH:mm:ss ZZ")
        var end = moment(val.end).format("DD/MMM/yyyy:HH:mm:ss ZZ") 
        this.refreshChart(start, end)
      },
      async refreshChart (start, end) {
        var that = this
        let params = {}
        params['start'] = start
        params['end'] = end
        var q = '/dt/v1/'+ this.deviceID + '?' +querystring.stringify(params) 
        this.loading = true
        axiosInstances.apiServer.get(q).then((res) => {
          this.loading = false
          if (res == null || res.data == null || res.data.length ==0) {
            that.sensorData = []
          } else {
            that.sensorData = res.data
          }
          
        })
      },
      handleResize () {
        this.www = window.innerWidth
        this.wwh= window.innerHeight
        this.$set(this.chartOptions, 'width', this.www - 100)
        this.$set(this.chartOptions, 'height', this.wwh - 255)
      },
      pad (d) {
        return (d < 10) ? '0' + d.toString() : d.toString();
      },
      // onReady (instance) {
      //   const that = this
      //   that.chart = instance
      // },
      onChartReady(chart, google){
        this.chart = chart
        var self = this
        google.visualization.events.addListener(chart, 'select', function () {
          var sel = chart.getSelection()
          if (sel.length <= 0) return
          if (sel[0].row != null) return
          var col = sel[0].column
          var d = google.visualization.arrayToDataTable(self.chartData)         
          if (self.columns[col] == col) {
            self.columns[col] = {
              label: d.getColumnLabel(col),
              type: d.getColumnType(col),
              calc: function () {
                return null
              }
            }
            self.series[col-1].color = '#CCCCCC'
          } else {
            self.columns[col] = col
            self.series[col - 1].color = null;
          }
          let view = new google.visualization.DataView(d)
          view.setColumns(self.columns)
          chart.draw(view, self.chartOptions)
        })
      },
      getDictionaryItem(code) {
        var obj = null
        this.dictionary.forEach(function(item) {
          if (item.code == code) {
            obj = item 
            return
          }
        })
        return obj
      }
    },
    async beforeMount () {
      await this.initLast200()
    },
    async mounted () {
      let device = this.orgSensors.find(el => el.deviceID == this.deviceID)
      this.chartOptions.title = device.name + ' (' + device.location + ')'
    },
    created () {
      const debouncedHandler = debounce(this.handleResize, 250);
      window.addEventListener('resize', () => {
        debouncedHandler()
      });
    },
    destroyed () {
      window.removeEventListener('resize', this.handleResize);
    }
  }
</script>

<style scoped>
  .echarts {
    width: 100%;
    height: 100%;
    margin-right: 3px;
    padding-right: 5px;
  }
  .device-selector {
    margin: 10px;
    width: 40%;
  }
</style>